import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";
import { Layout9 } from "../ContentBox";
import { DivHover, DivHelp } from "./styled";

class FAButtonView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }
  onHover = () => {
    this.setState({ hover: true });
  };
  onMouseOver = () => {
    this.setState({ hover: false });
  };
  render() {
    return (
      <DivHover
        onMouseLeave={this.onMouseOver.bind(this)}
        onMouseEnter={this.onHover.bind(this)}
      >
        <Layout {...this.props} type="FAButtonView" />
        {this.state.hover && <DivHelp>Content</DivHelp>}
      </DivHover>
    );
  }
}

FAButtonView.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  layout: PropTypes.func
};

FAButtonView.defaultProps = {
  childOf: "Content",
  values: {
    parent: "Content",
    type: "FAButtonView",
    containerPadding: "0px",
    disabled: false,
    mini: false,
    buttonAlign: "center",
    buttonColors: {
      color: "#FFF",
      backgroundColor: "#e61919",
      hoverColor: "#42d696",
      disabledColor: "#757575"
    },
    zDepth: 2,
    icon: "add",
    href: {
      url: "",
      target: ""
    }
  },
  layout: Layout9
};
export default FAButtonView;



// WEBPACK FOOTER //
// ./src/editor/layout/components/Content/FAButtonView.js